// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"490c2640","92":"bb363c97","213":"78a95529","239":"198698a9","453":"59865f2b","849":"0a79d192","904":"dfa71e20"}[chunkId] + ".chunk.js";
};